import { useEffect } from 'react'

const SCRIPT_SRC = 'https://widget.reviews.co.uk/snippet/dist.js'

const ReviewsIoWidget = ({ storeId }) => {
  useEffect(() => {
    if (!storeId) return
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return
    const script = document.createElement('script')
    script.src = SCRIPT_SRC
    script.async = true
    document.head.appendChild(script)
  }, [storeId])

  if (!storeId) return null

  return (
    <div style={{ marginTop: '0.4rem' }}>
      {/* Reviews.io custom element — initialised by their snippet script */}
      <ruk-rating-snippet store={storeId} />
    </div>
  )
}

export default ReviewsIoWidget
